import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "app-loading-modal",
	templateUrl: "./loading-modal.component.html",
	styleUrls: ["./loading-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class LoadingModalComponent {}
